export const OverallStates = {
  InReview: _TL_('In Review'),
  Approved: _TL_('Approved'),
  Active: _TL_('Active'),
  Rejected: _TL_('Rejected'),
  Stopped: _TL_('Stopped'),
  Expired: _TL_('Expired'),
};
